import { connect } from 'react-redux';
import PlanSelection from '../../components/Plans/Selection/Selection';
import PlansAction from '../actions/PlansAction';
import { PlansSelector } from '../reducers/PlansReducer';
import { ConfigSelector } from '../reducers/ConfigReducer';

const mapStateToProps = state => ({
  isContractSelected: PlansSelector.getIsContractSelected(state),
  modemPrice: PlansSelector.getModemPrice(state),
  technologyType: PlansSelector.getTechnologyType(state),
  basePrice: PlansSelector.getBasePrice(state),
  connectionPrice: PlansSelector.getConnectionPrice(state),
  shippingPrice: PlansSelector.getShippingPrice(state),
  term: PlansSelector.getContractTerm(state, true),
  offer: ConfigSelector.getGiftWithPurchase(state),
  discountWithSubscription: ConfigSelector.getDiscountWithSubscription(state),
  discount: ConfigSelector.getDiscount(state),
  giftWithPurchase: ConfigSelector.getGiftWithPurchase(state),
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state),
  selectedPlan: PlansSelector.getSelectedPlan(state),
  byoModemDiscountPrice: PlansSelector.getByoModemDiscountPrice(state),
  withMobileDiscount: PlansSelector.checkWithMobileDiscount(state),
});

const mapDispatchToProps = dispatch => ({
  setContractSelected: (isSelected) => {
    dispatch(PlansAction.setContractSelected(isSelected));
  }
});

const PlanSelectionContainer = connect(mapStateToProps, mapDispatchToProps)(PlanSelection);

export default PlanSelectionContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/PlanSelectionContainer.js
 **/